import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '@/views/Login';
import Signup from '@/views/Signup';
import RegisterToGame from '@/views/RegisterToGame';
import CurrentGame from '@/views/CurrentGame';
import Profile from '@/views/Profile';
import Admin from '@/views/admin';
import AdminHome from '@/views/admin/Home';
import AdminGame from '@/views/admin/Game';
import AdminCheck from '@/views/admin/CheckAnswers';
import AdminCreate from '@/views/admin/createGame';

import store from '@/store';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {path: '/Login', name: 'Login', component: Login},
  {path: '/Signup', name: 'Signup', component: Signup},
  {path: '/Gamelist/:gameid?', name: 'RegisterToGame', component: RegisterToGame, meta: {requiresAuth: true}, props: true},
  {path: '/game/:id', name: 'CurrentGame', component: CurrentGame, meta: {requiresAuth: true}, props: true},
  {path: '/Profile', name: 'Profile', component: Profile, meta: {requiresAuth: true}},
  {
    path: '/Admin', 
    component: Admin,
    meta: {requiresAuth: true},
    children: [
      {path: '', redirect: 'home'},
      {path: 'home', name: 'AdminHome', component: AdminHome, meta: {requiresAuth: true}},
      {path: 'games/:id', name: 'AdminGame', component: AdminGame, props: true, meta: {requiresAuth: true}},
      {path: 'game/:gameid/checkAnswers', name: 'AdminCheck', component: AdminCheck, props: true, meta: {requiresAuth: true}},
      {path: 'createGame', name: 'AdminCreate', component: AdminCreate, meta: {requiresAuth: true}}
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  try {
    const requiresAuth = to.matched.some(rec => rec.meta.requiresAuth);
    if(to.matched.some(rec => rec.name == 'Login') || 
    !requiresAuth ||
    (requiresAuth && store.getters.logged)) {
      next();
    } else {
      window.localStorage.setItem('redirect', to.path);
      next('/login');
    }
  } catch(e) {console.log('router exception', e.message)}
});


export default router
